export type OsaTimeRangeKey = 'wholeDay' | 'morning' | 'afternoon'

export interface OsaTimeRange {
  display: string
  defaultStart: string
  minTime: string
  maxTime: string
}

const OSA_TIME_RANGE_KEYS: readonly string[] = ['wholeDay', 'morning', 'afternoon']

/**
 * Latest possible appointment start hour, depending on the season of the appointment date:
 * - November to January: 14:00
 * - February: 15:00
 * - March to October: 16:00
 */
export const getOsaMaxHour = (appointmentDate: Date): number => {
  const month = appointmentDate.getMonth() + 1
  if (month >= 11 || month === 1) return 14
  if (month === 2) return 15
  return 16
}

// Time range configurations
export const getOsaTimeRanges = (appointmentDate: Date): Record<OsaTimeRangeKey, OsaTimeRange> => {
  const maxHour = getOsaMaxHour(appointmentDate)
  const maxTime = `${maxHour}:00`

  return {
    wholeDay: {
      display: `Ganztägig (9 Uhr bis ${maxHour} Uhr)`,
      defaultStart: '09:00',
      minTime: '09:00',
      maxTime,
    },
    morning: {
      display: 'Vormittags (9 Uhr bis 12 Uhr)',
      defaultStart: '09:00',
      minTime: '09:00',
      maxTime: '12:00',
    },
    afternoon: {
      display: `Nachmittags (13 Uhr bis ${maxHour} Uhr)`,
      defaultStart: '13:00',
      minTime: '13:00',
      maxTime,
    },
  }
}

export const isOsaTimeRangeKey = (value: string): value is OsaTimeRangeKey =>
  OSA_TIME_RANGE_KEYS.includes(value)

export const formatOsaTimeRange = (timeRange: string, appointmentDate: Date): string => {
  if (isOsaTimeRangeKey(timeRange)) {
    return getOsaTimeRanges(appointmentDate)[timeRange].display
  }
  return timeRange
}
